import React from "react";
import AuthenticationService from "../service/AuthenticationService";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
    switch (action.type) {
        case "LOGIN_SUCCESS":
            return { ...state, isAuthenticated: true };
        case "SIGN_OUT_SUCCESS":
            return { ...state, isAuthenticated: false };
        case "LOGIN_FAILURE":
            return { ...state, isAuthenticated: false };
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

function UserProvider({ children }) {
    let userData = JSON.parse(localStorage.getItem("userData"))
    var [state, dispatch] = React.useReducer(userReducer, {
        isAuthenticated: !!localStorage.getItem("access_token"),
        username: !!localStorage.getItem("userData") ? userData.username : null,
        permission: !!localStorage.getItem("userData") ? userData.permission : null,
    });

    return (
        <UserStateContext.Provider value={state}>
            <UserDispatchContext.Provider value={dispatch}>
                {children}
            </UserDispatchContext.Provider>
        </UserStateContext.Provider>
    );
}

function useUserState() {
    var context = React.useContext(UserStateContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within a UserProvider");
    }
    return context;
}

function useUserDispatch() {
    var context = React.useContext(UserDispatchContext);
    if (context === undefined) {
        throw new Error("useUserDispatch must be used within a UserProvider");
    }
    return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

async function loginUser(dispatch, login, password, recaptcha, history, setIsLoading, setError, setErrorMessages) {
    setError(false);
    setIsLoading(true);
    try {
        const res = await AuthenticationService.Login(login, password, recaptcha);
        if (res.status) {
            const { access_token, permission, username } = res
            localStorage.setItem('access_token', access_token)
            localStorage.setItem('userData', JSON.stringify({username, permission}))
            setError(null)
            setIsLoading(false)
            dispatch({ type: 'LOGIN_SUCCESS', permission, username })
            history.push('/app/dashboard')
        }
    } catch (error) {
        dispatch({ type: "LOGIN_FAILURE" });
        setError(true);
        setIsLoading(false);
        setErrorMessages(error.data ? error.data.message : error.message)
    }
}

function signOut(dispatch, history) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("userData")
    dispatch({ type: "SIGN_OUT_SUCCESS" });
    history.push("/login");
}
